/**
 * Действие найма этого хода, которое снимает двойной клик по отряду:
 * ПОСЛЕДНЕЕ действие этого отряда. Докупленный размер и улучшение снимаются
 * по одному, начиная с последнего, а сам найм отряда — в последнюю очередь:
 * он у отряда всегда первый, раньше него докупать и улучшать было нечего.
 */
export const findUnitUndoableRecruitmentAction = (pendingRecruitmentActions, unitId) => (
  (pendingRecruitmentActions || []).findLast((action) => action.unitId === unitId) || null
);
